// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchBanner_wrapper__4Urtq"};